import { useMarkToggle } from 'common/ProseInput/hooks/useMarkToggle'
import { schema } from 'common/ProseInput/Schema'
import { IconButton } from 'components/IconButton/IconButton'
import { FC } from 'react'
import { ReactComponent as BoldIcon } from 'assets/icons/bold16.svg'
import { ReactComponent as ItalicIcon } from 'assets/icons/italic16.svg'
import { ReactComponent as UnderlineIcon } from 'assets/icons/underline16.svg'
import { ReactComponent as InlineCodeIcon } from 'assets/icons/inlineCode16.svg'

import { MarkButtonProps } from './Types'
import { observer } from 'mobx-react-lite'

const MarkButton: FC<React.PropsWithChildren<MarkButtonProps>> = observer(({ markType, children }) => {
  const { isActive, isDisabled, onPress } = useMarkToggle(markType)
  return (
    <IconButton isDisabled={isDisabled} onPress={onPress} variant={isActive ? 'toggleOn' : 'toggleOff'}>
      {children}
    </IconButton>
  )
})

export const Bold = () => (
  <MarkButton markType={schema.marks.strong}>
    <BoldIcon />
  </MarkButton>
)
export const Italic = () => (
  <MarkButton markType={schema.marks.em}>
    <ItalicIcon />
  </MarkButton>
)
export const Underline = () => (
  <MarkButton markType={schema.marks.underline}>
    <UnderlineIcon />
  </MarkButton>
)
export const InlineCode = () => (
  <MarkButton markType={schema.marks.code}>
    <InlineCodeIcon />
  </MarkButton>
)
